export enum OverdueStateType {
    DEFAULT = 'DEFAULT',
    OVERDUE = 'OVERDUE',
    DOUBTFUL = 'DOUBTFUL',
    SUBSTANDARD = 'SUBSTANDARD',
    LOSS = 'LOSS'
}
